import BlogList from "../../Components/Blog/BlogList";
import Footer from "../../layout/Footer";
import Header from "../../layout/Header";
import Pagebanner from "../../layout/Banner";
import { Helmet } from "react-helmet-async";

const Blogs = () => {
  return (
    <>
      <Helmet>
        <title>Legal Blogs & Insights | R & P Law Partners</title>

        <meta
          name="description"
          content="Read expert legal blogs covering criminal, civil, corporate, cyber, family, and business law with practical legal insights and updates."
        />

        <meta name="keywords" content="Blogs" />

        <link rel="canonical" href="https://rplawpartners.com/blogs" />

        <noscript>
          Please enable JavaScript to view this page properly.
        </noscript>
      </Helmet>
      <Header />
      <Pagebanner title={"Legal Library"} subtitle={"Latest Legal Insights"} />
      <BlogList />
      <Footer />
    </>
  );
};
export default Blogs;
